module.exports = __webpack_public_path__ + "892a8afc29c1b6bff65b3fa26ac06d6b.svg";